<template>
  <bvc-input
    :class="$style.field"
    type="search"
    role="search"
    size="sm"
    slot-theme="none"
    :theme="theme"
    :placeholder="placeholder"
    :autocomplete="autocomplete"
    :readonly="readonly"
    :disabled="disabled"
    @focus="$emit('focus')"
    @blur="$emit('blur')"
    :value="value"
    @input="emitInput($event)"
    ref="input"
    :name="name"
  >
    <template #left>
      <b-svg
        name="search"
        :size="20"
        :class="$style.icon"
      />
    </template>
  </bvc-input>
</template>

<script>
import BvcInput from '@/booksy-vue-components/components/b-input/index.vue'
import VModelInterface from '@/booksy-vue-components/mixins/v-model-interface.js'

export default {

  emits: [
    'blur',
    'focus',
  ],
  props: {
    placeholder: {
      type: String,
      // TODO VUE3
      // default () {
      //   return this.$t('search')
      // },
    },
    theme: {
      type: String,
      default: 'filled',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    autocomplete: {
      type: String,
      default: 'off',
    },
    name: {
      type: String,
    },
  },

  mixins: [
    VModelInterface,
  ],

  components: {
    BvcInput,
  },

  methods: {
    focus () {
      this.$refs.input.focus()
    },

    blur () {
      this.$refs.input.blur()
    },
  },
}
</script>

<style lang="scss" module>
.icon {
  display: block;
  color: $color-gray-08;
}

.field {
  > div {
    padding-top: 8px!important;
    padding-bottom: 8px!important;
    // border: none!important;
  }
  input {
    font-size: 16px!important;
    line-height: 24px!important;
  }
}
</style>
